import React from 'react';

class AboutCompany extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/service.jpg')} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                            <h3 className="m-t0">Reliable Inspection Services for a Safer and Better Tomorrow.</h3>
                                            <p>Kami menghadirkan layanan riksa (pemeriksaan) yang terintegrasi dan terpercaya untuk memastikan setiap aspek memenuhi standar keamanan, kualitas, dan regulasi yang berlaku. Dengan mengutamakan ketelitian, akurasi, dan profesionalisme, setiap layanan kami dirancang untuk mendukung terciptanya lingkungan kerja dan hidup yang lebih aman, nyaman, dan berkelanjutan. Percayakan kebutuhan inspeksi Anda kepada tim ahli yang berpengalaman dan berdedikasi — karena kualitas dan keamanan adalah komitmen utama kami.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutCompany;